import React from "react";
import { useTranslation } from "react-i18next";
import { LinkToNode } from "components/common";
import {
  calculateInputMetricsByNode,
  getInputConnectionMetrics,
  formatCount
} from "components/inputs/helpers/InputThroughputUtils";
import { Connections, NetworkIOStats } from "components/inputs/InputsOveriew";
const NodeMetricsDetails = ({ input, metrics }) => {
  const { t } = useTranslation("inputs");
  const calculatedMetricsByNode = calculateInputMetricsByNode(input, metrics);
  return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("hr", null), Object.keys(calculatedMetricsByNode).map((nodeId) => {
    const {
      openConnections,
      totalConnections,
      emptyMessages,
      writtenBytes1Sec,
      writtenBytesTotal,
      readBytes1Sec,
      readBytesTotal
    } = getInputConnectionMetrics(input, calculatedMetricsByNode[nodeId] || {});
    return /* @__PURE__ */ React.createElement("span", { key: input.id + nodeId }, /* @__PURE__ */ React.createElement(LinkToNode, { nodeId }), /* @__PURE__ */ React.createElement("br", null), !isNaN(writtenBytes1Sec) && /* @__PURE__ */ React.createElement(
      NetworkIOStats,
      {
        writtenBytes1Sec,
        writtenBytesTotal,
        readBytes1Sec,
        readBytesTotal
      }
    ), /* @__PURE__ */ React.createElement("br", null), !isNaN(openConnections) && /* @__PURE__ */ React.createElement(Connections, { openConnections, totalConnections }), !isNaN(emptyMessages) && /* @__PURE__ */ React.createElement("span", null, t("overview.sections.empty_messages_discarded", { value: formatCount(emptyMessages) }), /* @__PURE__ */ React.createElement("br", null)), isNaN(writtenBytes1Sec) && isNaN(openConnections) && /* @__PURE__ */ React.createElement("span", null, t("overview.sections.no_node_metrics")));
  }));
};
export default NodeMetricsDetails;
